import { AfterViewInit, Component, ElementRef, EventEmitter, Injector, Input, OnChanges, OnInit, Output, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LocalStorageService } from '@app/@core/local-storage/local-storage.service';
import { AlertService } from '@app/@core/services/alert.service';
import { AppService } from '@app/@core/services/app.service';
import { AuthService } from '@app/@core/services/auth.service';
import { HttpService } from '@app/@core/services/http.service';
import { SharedService } from '@app/@core/services/shared.service';
import { LocalService } from '@core/services/local.service';
import { DynamicsearchService } from '@pics-core/dynamic';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import * as jsPDF from 'jspdf';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { GridYouthListService } from './app-grid-youth-list.service';
import { DataGridControlService } from './data-grid-control.service';
import { InAppNotificationService } from '@pics-core/common-utils';
const SELECT_ALL = 'Select-ALL';
const STORAGE_KEY_DYNAMIC_TAB_PAGES = 'dynamic-tab-pages';
@Component({
  standalone: false,
  selector: 'app-grid-youth-list',
  providers: [GridYouthListService],
  templateUrl: './app-grid-youth-list.component.html',
  styleUrls: ['./app-grid-youth-list.component.scss']
})
export class GridYouthListComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid!: DxDataGridComponent;
  @ViewChildren('contentWrapper') contentWrappers: QueryList<ElementRef>;
  @Input() dataList: any[];
  @Input() dataSource: DataSource;
  @Input() columns: any;
  @Input() updateGrid: any;
  @Input() totalCount: number;
  @Input() page: number;
  @Input() isShow: any;
  @Input() exportPageName: string;
  @Output() currentPage = new EventEmitter<number>();
  @Output() editTableRow = new EventEmitter<any>();
  @Output() viewTableRow = new EventEmitter<any>();
  @Output() deleteTableRow = new EventEmitter<any>();
  @Output() openExternalLink = new EventEmitter<any>();
  @Output() openpopupLink = new EventEmitter<any>();
  @Output() routeTo = new EventEmitter<any>();
  @Output() openPopup = new EventEmitter<any>();
  @Output() sortOrder = new EventEmitter<any>();
  @Output() filterSearchValue = new EventEmitter<any>();
  @Output() filterBuilderPopup = new EventEmitter<any>();
  @Output() filterPanel = new EventEmitter<any>();
  @Output() multipleFilterValues = new EventEmitter<any>();
  @Output() downloadTableRow = new EventEmitter<any>();
  @Output() rowSelection = new EventEmitter<any>();
  @Output() toggleRow = new EventEmitter<any>();
  @Output() duplicateRow = new EventEmitter<any>();
  @Output() viewVersions = new EventEmitter<any>();
  @Output() activateVersion = new EventEmitter<any>();
  @Output() activatePage = new EventEmitter<any>();
  @Output() deactivatePage = new EventEmitter<any>();
  @Output() duplicatePageVersion = new EventEmitter<any>();
  @Output() selectedRowsData = new EventEmitter<any>();
  orgList: any;
  dataField: string[];
  columnHeader: any[];
  popupPosition: any;
  filterValue: (string | string[])[];
  customOperations: any[];
  fields: any;
  customStore: any;
  tempColumns: any[];
  Organization: any;
  dUrl: string;
  rdUrl: string;
  rUrl: any;
  user: any;
  userId: number;
  tempList: any[];
  showVersions: boolean;
  displayMode: any;
  registrationInfo: any;
  activepagename: any;
  url: any;
  oldUrl: any;
  dynamicSearchService: any;
  columnWidth: any;
  screenWidth: number;
  storage: any;
  gridconfig: any;
  filterForm!: UntypedFormGroup;
  gridOptions: { value: string; label: string; code: string }[];
  filterOptions: any[];
  gridId: string;
  alertService: AlertService;
  inAppNotificationService: InAppNotificationService;
  dataGridControlService: DataGridControlService;
  storageService: LocalStorageService;
  localstorage: LocalService;
  httpService: HttpService;
  sharedService: SharedService;
  subscription: Subscription;
  constructor(
    injector: Injector,
    private router: Router,
    public auth: AuthService,
    private appService: AppService,
    private fb: UntypedFormBuilder,
    private renderer: Renderer2,
  ) {
    this.alertService = injector.get<AlertService>(AlertService);
    this.inAppNotificationService = injector.get<InAppNotificationService>(InAppNotificationService);
    this.dataGridControlService = injector.get<DataGridControlService>(DataGridControlService);
    this.storageService = injector.get<LocalStorageService>(LocalStorageService);
    this.localstorage = injector.get<LocalService>(LocalService);
    this.httpService = injector.get<HttpService>(HttpService);
    this.sharedService = injector.get<SharedService>(SharedService);
    this.showVersions = false;
    this.loadGWithParam();
    this.user = this.localstorage.getObj('user');
    this.userId = this.localstorage.getItem('id');
    this.rUrl = this.router.url.split('/');
    if (this.rUrl.includes('versions')) {
      this.showVersions = true;
    }
    this.displayMode = 'compact';
    this.gridOptions = [
      { label: 'Sorting', value: 'sort', code: '' },
      { label: 'Filtering', value: 'filter', code: '' },
      { label: 'Hide', value: 'hide', code: '' },
      { label: 'Fixed', value: 'fixed', code: '' },
      // { label: 'Default Columns', value: 'Choosable', code: '' },
      { label: 'Visible', value: 'visible', code: '' },
      { label: 'Date', value: 'dateFormat', code: '' },
      { label: 'Mobile', value: 'mobileView', code: '' },
      { label: 'Tablet', value: 'tabView', code: '' }
    ];
    this.dynamicSearchService = injector.get<DynamicsearchService>(DynamicsearchService);
    this.gridId = 'youth-search-grid';
  }

  ngOnInit() {
    if (this.isShow === false) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }

    this.tempColumns = this.columns;
    if (this.columns && this.columns.gridConfigFormArray) {
      this.columnHeader = this.columns.gridConfigFormArray.map(column => column.header);
      this.columns = this.columns.gridConfigFormArray;
    } else {
      this.columnHeader = this.columns.map(column => column.header);
    }
    this.popupPosition = { of: window, at: 'top', my: 'top', offset: { y: 10 } };
    this.filterValue = [];
    this.customOperations = [];
    this.loadFilterForm();
    this.subscription = this.dataGridControlService.clearActions$.subscribe(() => {
      this.clearSortingAndFiltering();
    });
  }

  loadFilterForm() {
    this.filterForm = this.fb.group({
      selectedFilter: ['']
    });
  }

  ngOnChanges() {
    this.loadGWithParam();
  }
  contentReady = e => {
    const componentInstance = e.component.instance();
      const currentColumns = componentInstance.option('columns');
      if (this.columns) {
          let changesMade = false;
          currentColumns.forEach((column, index) => {
              const configItem = this.columns.find(c => c.columnDef === column.dataField);
              if (configItem) {
                  const targetVisibility = configItem.hide ? false : (configItem.visible === "" ? true : configItem.visible);
                  if (column.visible !== targetVisibility) {
                      changesMade = true;
                      currentColumns[index].visible = targetVisibility;
                  }
                  // Check and update the visibleIndex if different
                  if (column.visibleIndex !== configItem.visibleIndex) {
                    changesMade = true;
                    currentColumns[index].visibleIndex = configItem.visibleIndex;
                  }
              }
          });

          if (changesMade) {
              componentInstance.option('columns', currentColumns);
          }
      }
  };

  customSave = (state: any) => {
    for (const item in state) {
      if (item !== 'columns') delete state[item];
    }
    this.columns.pageSize = this.dataGrid.instance.pageSize();
    this.columnWidth = state;
    if (state?.columns != undefined) {

      state.columns.forEach((stateColumn) => {
        const configItem = this.columns.find(c => c.columnDef === stateColumn.dataField && !c.hide);
        if (configItem) {
            configItem.width = stateColumn.width;
            configItem.filterValues = stateColumn.filterValues;
            configItem.sortOrder = stateColumn.sortOrder;
            configItem.sortIndex = stateColumn.sortIndex;
            configItem.visible = stateColumn.visible ?? true;
            configItem.visibleIndex = stateColumn.visibleIndex;
            configItem.filterValue = stateColumn.filterValue;
            configItem.filterType = stateColumn.filterType;
            configItem.selectedFilterOperation = stateColumn.selectedFilterOperation;
        }
      });
      const body = {
        type: 'STATIC_GRID',
        mappedid: this.gridId,
        config: JSON.stringify(this.columns)
      };
      this.dynamicSearchService.saveGridUserPreference(body).subscribe();
      }
    }
    getUserGridConfig() {
      this.dynamicSearchService.getStaticGridConfig(this.gridId).subscribe((res: any) => {
        if (res.data && res.data?.config) {
          const configArray = JSON.parse(res.data.config);
          if (configArray ) {
            this.gridconfig = configArray;
            this.columns = configArray;
            const storedTabData = JSON.parse(JSON.parse(this.storage.getItem(STORAGE_KEY_DYNAMIC_TAB_PAGES)));
            storedTabData?.map(item => {
              this.columns.map(item1 => {
                if (item.pfield == item1.columnDef) {
                  item1.link = item.pfield;
                }
              });
            });
  
            this.columns.map(c => {
              c?.selected?.map(s => Object.assign({ col_ref: `${c.columnDef}-${s}` }, c));
            });
            const options = [];
            const arr = [];
            configArray.map(a => {
              options.push({
                columnName: a.header,
                items: this.gridOptions.map(p => ({
                  id: `${a.columnDef}-${p.value}`,
                  label: p.label,
                  value: p.value,
                  code: a.columnDef,
                  active: a[p.value] !== '' ? true : ''
                }))
              });
              a?.selected?.map(r => arr.push(`${a.columnDef}-${r}`));
            });
            this.columnsFilteration();
            this.filterOptions = options;
            this.filterForm.patchValue({ selectedFilter: arr });
          } else {
            this.patchMultipleOptions();
          }
        } else {
          this.patchMultipleOptions();
        }
      });
    }

    patchMultipleOptions() {
      if (this.gridconfig) {
        this.columnHeader = this.gridconfig.map(column => column.header);
        this.columns = this.gridconfig;
        this.columns.map(c => {
          c?.selected?.map(s => Object.assign({ col_ref: `${c.columnDef}-${s}` }, c));
        });
        const options = [];
        const arr = [];
        this.gridconfig.map(grid => {
          options.push({
            columnName: grid.header,
            items: this.gridOptions.map(p => ({
              id: `${grid.columnDef}-${p.value}`,
              label: p.label,
              value: p.value,
              code: grid.columnDef,
              active: grid[p.value] !== '' ? true : ''
            }))
          });
          grid?.selected?.map(r => arr.push(`${grid.columnDef}-${r}`));
        });
        this.columnsFilteration();
        this.filterOptions = options;
        this.filterForm.patchValue({ selectedFilter: arr });
      }
    }

    columnsFilteration() {
      this.columns = this.columns.map(x => {
        if (x['concatenate']) {
          const columnName = x.header.toLowerCase();
          const cName = columnName.replace(/ /g, '_');
          x.columnDef = `alias.${cName}`;
          return x;
        } else {
          return x;
        }
      });
    }

  
  loadGWithParam() {
    this.tempList = this.dataList;
    if (this.tempList) {
      const activeItems = this.tempList.filter(item => item.isactive);
      if (activeItems.length > 0) {
        this.activepagename = activeItems[0].pagename;
      }
    }    
    if (!this.auth.isAdmin()) {
      this.loadGrid({ value: !this.Organization ? this.auth.getOrgID() : this.Organization }, false);
    } else {
      this.loadGrid({ value: this.Organization ? this.Organization : SELECT_ALL }, false);
    }
  }

  ngAfterViewInit() {
    this.dataGrid.onOptionChanged.subscribe(e => {
      if (e.name === 'columns' && e.fullName.endsWith('filterValues')) {
        const colIndex = Number(
          e.fullName
            .match(/\[\d+\]/)[0]
            .replace('[', '')
            .replace(']', '')
        );
        const values = e.component.columnOption(colIndex, 'filterValues');
        console.log(values);
        this.multipleFilterValues.emit(e);
      }

      // Search
      if (e.name === 'columns' && e.fullName.endsWith('filterValue')) {
        console.log(e);
        this.filterSearchValue.emit(e);
      }

      // filter Builder Popup

      if (e.name === 'filterBuilderPopup') {
        console.log('filterBuilderPopup');
        console.log(e);
        this.filterBuilderPopup.emit(e);
      }

      // filter Panel - enable or disable
      if (e.name === 'filterPanel') {
        console.log(e.value);
        this.filterPanel.emit(e);
      }

      // Sorting
      if (e.name === 'columns' && e.fullName.endsWith('sortOrder')) {
        this.sortOrder.emit(e);
      }

      // Paging
      if (e.name === 'paging') {
        this.currentPage.emit(e.value);
      }
    });
    const REGISTRATION = this.storageService.getItem('REGISTRATION');
    if (REGISTRATION) {
      this.registrationInfo = JSON.parse(REGISTRATION);
    }

    this.contentWrappers.changes.subscribe((comps: QueryList<ElementRef>) => {
      comps.forEach(wrapper => {
        this.applyLinkStyles(wrapper);
      });
    });
    this.getUserGridConfig();

  }

  private applyLinkStyles(wrapper: ElementRef) {
    const anchors = wrapper.nativeElement.querySelectorAll('a');
    anchors.forEach(anchor => {
      this.renderer.setStyle(anchor, 'color', '#0049E5');
      this.renderer.listen(anchor, 'mouseenter', () => {
        this.renderer.setStyle(anchor, 'opacity', '0.5');
      });
      this.renderer.listen(anchor, 'mouseleave', () => {
        this.renderer.setStyle(anchor, 'opacity', '1');
      });
    });
  }

  loadGrid(orgID, load = true) {
    this.Organization = orgID.value;
    if (load) {
      this.currentPage.emit(orgID.value === SELECT_ALL ? 'all' : orgID.value);
    }

    if (this.tempList && this.tempList.length) {
      this.tempGridList(orgID);
    } else {
      this.customStore = this.dataSource;
    }
  }
  tempGridList(orgID) {
    if (orgID && orgID.value) {
      this.splitGridList(orgID);
    }
    if (this.dataList.length === 1 && this.rUrl && this.rUrl[2] === 'view-dashboard') {
      this.dUrl = 'view-dashboard/dashboard';
      this.router.navigateByUrl(`pages/${this.dUrl}/${this.dataList[0]['id']}`);
    }
    // Quick change
    this.customStore = new CustomStore({
      load: _opts => Promise.resolve(this.dataList),
      totalCount: _opts => Promise.resolve(this.totalCount)
    });
  }
  splitGridList(orgID) {
    this.dataList = this.tempList.filter(data => data.organizationid);
    this.dataList = this.tempList.filter(data => data.organizationid === orgID.value);
    if (this.tempList && this.tempList.length && this.tempList[0].displayname && this.tempList[0].userworkinfo) {
      this.dataList = this.tempList.filter(
        data => data.userworkinfo && data.userworkinfo[0] && data.userworkinfo[0].organizationid
      );
      this.dataList = this.tempList.filter(
        data => data.userworkinfo && data.userworkinfo[0] && data.userworkinfo[0].organizationid === orgID.value
      );
    }
    if (SELECT_ALL === orgID.value) {
      this.dataList = this.tempList;
    }
  }

  getRouter(data) {
    this.routeTo.emit(data);
  }

  navigateLink(event: MouseEvent, _rowData: any) {
    const target = event.target as HTMLAnchorElement;
    if (target.tagName === 'A' && target.href) {
      this.updateNotificationView(_rowData);
      this.url = this.extractUrl(target.outerHTML);
      this.oldUrl = this.extractUrl(target.outerHTML);
      const activeId = this.extractID(this.url.split('?')[0]);
      const isNumberCheck = Number(activeId);
      const urlParams = new URLSearchParams(this.url.split('?')[1]);
      const pageID = urlParams.get('pageID');
      event.preventDefault();
      if(pageID){
        this.inAppNotificationService.checkPageAccessForUser(pageID).subscribe((res: any) => {
          if(res['data']){
            this.checkPageId(isNumberCheck, activeId, event);
          } else {
            event.preventDefault();
            this.alertService.error("Page Not Available: You don't have the necessary permissions to view this page.");
          }
        }, (_error) => {
          event.preventDefault();
          this.alertService.error("An error occurred while checking page access.");
        });
      } else {
        event.preventDefault();
        this.alertService.error("Page Not Available");
      }
    }
  }

  async checkPageId(isNumberCheck, activeId, event) {
    if (isNumberCheck) {
      const menus = this.localstorage.getObj('MENU');
      const findMenu = menus.find(item => item.name === 'Pages');
      let isExists;
      if(findMenu && findMenu.length > 0){
        isExists = findMenu.submenu.find(item => item.id == isNumberCheck);
      }
      if(isExists){
        this.url = this.url.replace(activeId, isExists?.activeVersion?.pageid);
        this.routeFunction(isNumberCheck, activeId, event, 'mainMenuWithId');
      } else {
        this.routeFunction(isNumberCheck, activeId, event, 'Pages');
      }
    } else {
      this.routeFunction(isNumberCheck, activeId, event, 'mainMenuWithURL');
    }
  }

  routeFunction(isNumberCheck, activeId, event, _menuType){
    const menus = this.localstorage.getObj('MENU');
    const mainMenu = menus.find(item => item.route === this.url);
    const mainMenuWithUrl = menus.find(element => this.url.endsWith(element.route));
    if(mainMenuWithUrl) {
      this.appService.addValue('CurrentPages', mainMenuWithUrl);
      this.auth.getCurrentMenu(menus);
    } else if(mainMenu){
      menus.forEach(element => {
        if(element.name === mainMenu.name){
          element.active = true;
        } else {
          element.active = false;
        }
      });
      if(isNumberCheck){
        this.appService.addValue('dynamicPages', mainMenu);
        this.auth.getCurrentMenu(menus);
      } else {
        this.appService.addValue('currentPages', mainMenu);
        this.auth.getCurrentMenu(menus);
      }
    } else {
      menus.forEach((element, index) => {
        if(element.submenu.length > 0){
          element.submenu.forEach((element1, index1) => {
            if(element1?.route == this.url || element1?.activeVersion?.pageid == activeId || element1?.activeVersion?.id == activeId){
              this.setActive(menus, index, index1, isNumberCheck);
            }
          }); 
        }
      });
    }
    this.router.navigateByUrl(this.oldUrl);
    event.preventDefault();
  }

  setActive(menus: any, menuIndex, submenuIndex, isNumberCheck){
    menus.map(item => item.active = false);
    menus.forEach(element => {
      element.submenu.map(item => item.active = false);
    });
    if(menuIndex){
      menus[menuIndex].active = true;
      if(submenuIndex >= 0) {
        menus[menuIndex].submenu[submenuIndex].active = true;
      } else {
        menus[menuIndex].active = true;
      }
    } else {
      menus[0].active = true;
    }
    if(isNumberCheck){
      this.appService.addValue('dynamicPages', menus[menuIndex]);
      this.auth.getCurrentMenu(menus);
    } else {
      this.appService.addValue('currentPages', menus[menuIndex]);
      this.auth.getCurrentMenu(menus);
    }
  }

  extractID(url: string){
    const parts = url.split("/"); 
    const lastIndex = parts.length - 1;
    return parts[lastIndex];
  }

  extractUrl(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const link = doc.querySelector('a');
    return link ? link.getAttribute('href') : '';
  }

  popup(data) {
    this.openPopup.emit(data);
  }

  downloadData(evt) {
    this.downloadTableRow.emit(evt);
  }

  onSelectionChanged(evt) {
    this.rowSelection.emit(evt);
  }

  editData(evt) {
    this.editTableRow.emit(evt);
  }
  viewData(evt) {
    this.viewTableRow.emit(evt);
  }
  viewVersion(evt) {
    this.viewVersions.emit(evt);
  }

  activatePageVersion(evt) {
    this.activateVersion.emit(evt);
  }

  activatePages(evt) {
    this.activatePage.emit(evt);
  }
  deactivatePages(evt) {
    this.deactivatePage.emit(evt);
  }
  deleteData(evt) {
    this.deleteTableRow.emit(evt);
  }
  openLink(evt) {
    this.openExternalLink.emit(evt);
  }
  openPopupLink(evt) {
    this.openpopupLink.emit(evt);
  }
  activeUser(evt) {
    this.toggleRow.emit(evt);
  }
  duplicateDate(evt) {
    this.duplicateRow.emit(evt);
  }
  duplicateVersion(evt) {
    this.duplicatePageVersion.emit(evt);
  }

  getOrgList() {
    this.httpService.get('/platform/page-designer/page/organization/all').subscribe((data: any) => {
      if (data.data && data.data.length) {
        this.orgList = data.data.sort((a, b) => a.organizationname?.localeCompare(b.organizationname));
      } else {
        this.orgList = [];
      }
    });
  }


  onRowPrepared(e) {
    if (e.rowType === 'data') {
      e.columns.forEach((column, index) => {
        if (column.caption === 'Task') {
          e.rowElement.cells[index].classList.add('message-new');
        }
      });
  
      if (e.data.isnew) {
        const element = e.rowElement;
        element.classList.add('isnew');
        e.columns.forEach((column, index) => {
          if (column.caption === 'Task') {
            e.rowElement.cells[index].classList.add('new-icon');
          }
        });
      }
    }
  }

  onCellPrepared(e) {
    if (e.rowType == 'data' && e.data.isactive) {
      if (e.column.dataField === 'version') {
        const element = e.cellElement;
        const livetext = document.createElement('div');
        element.classList.add('live-td');
        livetext.classList.add('live-group');
        livetext.innerHTML = '<div class="live-text">Live</div>';
        element.appendChild(livetext);
      } else if (e.column.dataField === 'templatename') {
        this.exportPageName = e.value.includes('_') ? e.value.split('_')[0] : e.value;
      }
    }
  }
  onExporting(e) {
    const pageName = this.localstorage.getObj('FILE EXPORT NAME');
    const currentDate = moment().format('YYYY-MM-DD');
    let fileName: string;
    if (pageName) {
      fileName = `${pageName} Versions ${currentDate}`;
    } else if (this.exportPageName) {
      fileName = `${this.exportPageName}-${currentDate}`;
      if (this.exportPageName === 'version') fileName = `${this.exportPageName}-${currentDate}`;
    } else {
      fileName = `Dynamic-Pages ${currentDate}`;
    }
    e.component.columnOption('Action', 'visible', false);
    if (e.format === 'pdf') {
      const doc = new jsPDF.jsPDF();
      exportDataGridToPdf({
        jsPDFDocument: doc,
        component: e.component,
        customizeCell: grid => {
          grid.pdfCell.wordWrapEnabled = true;
        }
      }).then(() => {
        doc.save(`${fileName}.pdf`);
        e.component.columnOption('Action', 'visible', true);
      });
    } else if (e.format === 'xlsx') {
      e.fileName = fileName;
      setTimeout(() => {
        e.component.columnOption('Action', 'visible', true);
      }, 500);
    }
  }

  islocked(grid, user) {
    if (grid.lock && user.locked) {
      return Number(user.lockedby) === Number(this.userId);
    } else {
      return true;
    }
  }
  getDateFormat(value: any) {
    if (this.registrationInfo) {
      if (value === 'date') {
        return this.registrationInfo['datetimeformat'].split(' ')[0];
      }
      return this.registrationInfo['datetimeformat'];
    }
    return 'MM/dd/yyyy';
  }

  isEnable(grid, record) {
    return grid.version && record.isEnable;
  }

  clearSortingAndFiltering() {
    this.dataGrid.instance.clearFilter();
    this.dataGrid.instance.clearSorting();
  }

  updateNotificationView(rowData){
    const inputRequest = {
      isnew: false
    };
    const model = rowData?.data;
    this.inAppNotificationService.updateNotification(model?.id, inputRequest).subscribe((_res: any) => {
      this.sharedService.sendMessage();
    });
  }
}
